import { Bible as basicBible, Site as basicSite, Book as basicBook, Chapter as basicChapter } from "./Bible";

// OfflineState describes the download state of an object (site, Bible, or chapter).
export enum OfflineState {
    online_only = -1,
    remote = 0,
    failed,
    pending,
    paused,
    downloading,
    local = 100 // download complete
}

export interface Offlineable {
    offlineState?: OfflineState;
    deepOfflineState?: OfflineState;
}

export interface Chapter extends basicChapter, Offlineable {
}

export interface Book extends basicBook, Offlineable {
    chapters?: Chapter[];
}

export interface Bible extends basicBible, Offlineable {
    books?: Book[];
}

export interface Site extends basicSite, Offlineable {
    bibles?: Bible[];
    bibleIds?: string[]; // when storing bibles separately from the site, this is an array of ids and .bibles = []
}
